<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    :minimalize="minimalize"
  >
    <BaseInput
      :label="
          localStorage.translations.pages['setting-project_type']['dialog-add_edit-labels'][
            'segment-vida-deyatelnosti'
          ]
        "
      v-model="segments"
      :items="businessSegmentAll"
      item-text="name"
      item-value="id"
      multiple
      chips
      type="select"
      :placeholder="
          localStorage.translations.pages['setting-project_type']['dialog-add_edit-labels'][
            'segment-vida-deyatelnosti'
          ]
        "
      prepend-inner-icon="mdi-format-list-bulleted"
      append-icon="fas fa-angle-down"
    />
    <BaseInput
      :label="
          localStorage.translations.pages['setting-project_type']['dialog-add_edit-labels'][
            'tip-proekta'
          ]
        "
      v-model="name"
      prepend-inner-icon="mdi-format-list-text"
      :rules="['required', 'max100']"
      :placeholder="
          localStorage.translations.pages['setting-project_type']['dialog-add_edit-labels'][
            'tip-proekta'
          ]
        "
    />
  </TemplateModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProjectTypeModal',
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    create: Boolean,
    minimalize: Boolean,
    segmentId: {
      type: [Number, String],
      default: null,
    },
  },
  data: () => ({
    name: '',
    segments: [],
  }),
  computed: {
    ...mapGetters('workBusinessSegment', ['businessSegmentAll']),
    ...mapGetters('workProjectType', ['workProjectTypeShow']),
    SettingProjectTypePage() {
      return this.$route.name === 'SettingProjectType'
    },
    SalesProjectCreatePage() {
      return this.$route.name === 'SalesProjectCreate'
    },
    t() {
      return this.localStorage.translations.pages['setting-project_type']
    },
    text() {
      return {
        button: {
          open: this.t['dialog-add_edit'][
            this.create ? 'sozdanie-tipa-proekta' : 'redaktirovanie-tipa-proekta'
          ],
        },
        title: {
          create: this.t['dialog-add_edit']['sozdanie-tipa-proekta'],
          edit: this.t['dialog-add_edit']['redaktirovanie-tipa-proekta'],
        },
      }
    },
  },
  watch: {
    workProjectTypeShow() {
      this.name = this.workProjectTypeShow.name
      if (this.workProjectTypeShow.segments) {
        this.segments = this.workProjectTypeShow.segments.map((i) => i.id)
      }
    },
  },
  methods: {
    ...mapActions('workProjectType', [
      'onWorkProjectTypeShow',
      'onWorkProjectTypeCreate',
      'onWorkProjectTypeGrid',
      'onWorkProjectTypeUpdate',
      'onWorkProjectTypeAllSegment',
      'onWorkProjectTypeAll',
    ]),
    ...mapActions('workBusinessSegment', ['onBusinessSegmentAll']),
    onOpen() {
      this.onBusinessSegmentAll()
      if (this.create) {
        this.name = ''
        this.segments = []
      } else {
        this.onWorkProjectTypeShow(this.id)
      }
      if (this.SalesProjectCreatePage) {
        this.segments.push(this.segmentId)
      }
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    async onSave() {
      if (this.create) {
        let data = {
          name: this.name,
          business_segments: this.segments,
        }
        await this.onWorkProjectTypeCreate(data)
          .then(() => {
            if (this.SettingProjectTypePage) {
              this.onWorkProjectTypeGrid({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
              })
            } else {
              this.onWorkProjectTypeAllSegment(this.segmentId)
            }
          })
      } else {
        let data = {
          id: this.workProjectTypeShow.id,
          name: this.name,
          business_segments: this.segments,
        }
        await this.onWorkProjectTypeUpdate(data)
          .then(() => {
            this.onWorkProjectTypeGrid({
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
          })
      }
    },
  },
}
</script>
